import { useState, useContext } from 'react'
import { QuoteContext } from '../context/context'

// Utility functions
import { sendQuoteEmail, resolveCurrentAgent } from '../utils/send-quote-email'

// UI components
import Button from '../../../components/ui/button/button'

// Returns the HTML markup and functionality to send the PDF quotes to the client
export default function Summary({ progressStage }) {
    const [sending, setSending] = useState(false)

    // Pull some getting & setting methods from the quote context
    const { ctxCompletedPackages, ctxClientID, ctxClientFirstName, ctxClientLastName, ctxClientEmail } = useContext(QuoteContext)

    // Process the request to send through the quote(s) to the client
    const processQuoteSend = async () => {
        // Set the state
        setSending(true)

        // Get the sales agent details
        const agent = await resolveCurrentAgent()

        // Loop through the completed packages and send the email (shared helper
        // is the single source of truth for the quote-send email shape + log)
        for (const quoteObject of ctxCompletedPackages) {
            await sendQuoteEmail({
                reference: quoteObject.reference,
                pdfBytesBase64: quoteObject.pdf_bytes,
                clientID: ctxClientID,
                clientName: `${ctxClientFirstName} ${ctxClientLastName}`,
                clientEmail: ctxClientEmail,
                agent,
            })
        }

        // Reset the state
        setSending(false)
        progressStage()
    }

    return (
        <>
            <div className='generate-quote-header'>
                <div className='generate-quote-title'>Quote Summary</div>
                <div className='generate-quote-subtitle'>Enter the clients email address below to have it sent to them &amp; saved</div>
            </div>

            <div className='quote-action-buttons'>
                <Button
                    label={`Send quote${ctxCompletedPackages.length > 1 ? 's' : ''}`}
                    loading={sending}
                    loadingText='Sending quote...'
                    onClick={() => processQuoteSend()} />
            </div>
        </>
    )
}